function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 5.18923V16.1538C24 17.1739 23.6049 18.1522 22.9016 18.8735C22.1984 19.5948 21.2446 20 20.25 20H3.75C2.75544 20 1.80161 19.5948 1.09835 18.8735C0.395088 18.1522 0 17.1739 0 16.1538V5.18923L11.619 12.2015C11.7344 12.2714 11.866 12.3082 12 12.3082C12.134 12.3082 12.2656 12.2714 12.381 12.2015L24 5.18923ZM20.25 4.76195e-08C21.1727 -0.000148794 22.0631 0.348626 22.7508 0.9796C23.4385 1.61057 23.8753 2.47945 23.9775 3.42L12 10.6462L0.0225002 3.42C0.124737 2.47945 0.561486 1.61057 1.24919 0.9796C1.9369 0.348626 2.82728 -0.000148794 3.75 4.76195e-08H20.25Z",
  fill: "black"
});

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.b3e50248.svg";
export { ForwardRef as ReactComponent };